import { PostGeoConfigLocation } from 'pages/Settings/GeoConfigSettings/api/useGeoConfig/useGeoConfig';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './PinDetail.module.scss';

export interface PinDetailProps {
  location: PostGeoConfigLocation;
}

/**
 * PinDetail
 */
export default function PinDetail({ location }: PinDetailProps) {
  return (
    <div className={styles.pinDetails}>
      <div className={styles.pinDetail}>
        <Text size='14' fontWeight={5}>
          Latitude:
        </Text>
        <Text size='14' fontWeight={4}>
          {location.latitude}
        </Text>
      </div>
      <div className={styles.pinDetail}>
        <Text size='14' fontWeight={5}>
          Longitude:
        </Text>
        <Text size='14' fontWeight={4}>
          {location.longitude}
        </Text>
      </div>
      <div className={styles.pinDetail}>
        <Text size='14' fontWeight={5}>
          Radius:
        </Text>
        <Text size='14' fontWeight={4}>
          {location.radius}
        </Text>
      </div>
    </div>
  );
}
